export function formatTierMutationError(error: unknown) {
  if (error && typeof error === "object" && "message" in error) {
    return String((error as {message: unknown}).message);
  }
  return "Something went wrong.";
}
